
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7rOWN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2sp5n = parcelRequire("2sp5n");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $iwIwp = parcelRequire("iwIwp");


var $99TtX = parcelRequire("99TtX");


var $1NFwk = parcelRequire("1NFwk");


var $9F0bu = parcelRequire("9F0bu");


var $85cI7 = parcelRequire("85cI7");


var $7tMWI = parcelRequire("7tMWI");


var $8iBLq = parcelRequire("8iBLq");


var $aaqIB = parcelRequire("aaqIB");

/**
 * IDs of the MAUI-specific experiences (the AI "Remix"/malleable diagram flow).
 *
 * These are gated on the `cc-maui-experiment` experiment rather than the
 * product-specific non-MAUI rollout gates, so that a rollback of
 * `cc-maui-experiment` disables the MAUI experiences without affecting generic
 * native embeds (Pages, Databases, Slides, non-MAUI Whiteboards).
 *
 * `MauiWhiteboardExperienceManifest` only matches whiteboard URLs with
 * `isRemixDiagram=true` (i.e. diagrams created via the MAUI flow). When it is
 * disabled, such URLs fall through to the generic `WhiteboardExperienceManifest`
 * (which matches the same whiteboard path without the `isRemixDiagram` param), so
 * the board still renders as a plain native-embed whiteboard.
 */ const $ab76b84281e6545b$var$mauiExperienceIds = new Set([
    (0, $9F0bu.MAUI_EXPERIENCE_MANIFEST_ID),
    (0, $85cI7.MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID)
]);
const $ab76b84281e6545b$var$allExperiences = [
    (0, $1NFwk.DBEntryExperienceManifest),
    (0, $99TtX.DBExperienceManifest),
    (0, $9F0bu.MauiExperienceManifest),
    (0, $7tMWI.PageExperienceManifest),
    (0, $8iBLq.SlideExperienceManifest),
    // MauiWhiteboardExperienceManifest must come before WhiteboardExperienceManifest
    // so its more specific isUrlMatch (requiring isRemixDiagram=true) is checked first.
    (0, $85cI7.MauiWhiteboardExperienceManifest),
    (0, $aaqIB.WhiteboardExperienceManifest)
];
const $ab76b84281e6545b$var$gatedExperiences = $ab76b84281e6545b$var$allExperiences.map((experience)=>({
        ...experience,
        isUrlMatch: (url)=>{
            if ($ab76b84281e6545b$var$mauiExperienceIds.has(experience.id)) return (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && experience.isUrlMatch(url);
            // Feature-flag names must remain static literals for static feature-flag tooling.
            return ((0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience') || (0, $iDrrr.fg)('platform_native_embeds_rollout_jira_non_maui')) && experience.isUrlMatch(url);
        }
    }));
// Register all experience manifests at module-load time.
// This is intentionally module-level (not inside a React lifecycle) because the
// facade must be available before any child embed loads.
(0, $iwIwp.getNativeEmbedFacade)().setup({
    experiences: $ab76b84281e6545b$var$gatedExperiences
});

const $ab76b84281e6545b$var$createRenderFn = (isPublishedPage, api, renderOverlay, analyticsPageContext)=>async ()=>{
        const { default: Ui } = await (parcelRequire("bx1QU"));
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Ui, {
                ...props,
                api: api,
                isPublishedPage: isPublishedPage,
                renderOverlay: renderOverlay,
                analyticsPageContext: analyticsPageContext
            });
    };
const $ab76b84281e6545b$export$622e7486b3a76ca4 = (isPublishedPage, api, cardClient, renderOverlay, analyticsPageContext)=>{
    // Wire up the CardClient for short-link URL resolution when provided.
    // This is a separate call from setup() because the CardClient may not be
    // available at module-load time when setup() is called.
    if (cardClient) (0, $iwIwp.getNativeEmbedFacade)().setCardClient(cardClient);
    return {
        title: 'Native Embed',
        type: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
        key: (0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY),
        description: 'Embed native Atlassian content',
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                },
                ...Object.fromEntries((0, $iwIwp.getNativeEmbedFacade)().getAllExperienceIds().map((experienceId)=>[
                        experienceId,
                        {
                            type: 'extension',
                            render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                            __hideFrame: true
                        }
                    ]))
            }
        }
    };
};
module.exports["createManifest"] = $ab76b84281e6545b$export$622e7486b3a76ca4;

});

parcelRegister("iwIwp", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6Iq0g = parcelRequire("6Iq0g");


var $h2POc = parcelRequire("h2POc");

/**
 * Matches Confluence short-link URLs of the form /wiki/x/<token>.
 * These URLs do not map to a specific experience until resolved via ORS.
 */ const $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN = /\/wiki\/x\/[^/]+/;
let $3b2da6bf08d8f744$var$nativeEmbedFacade;
function $3b2da6bf08d8f744$export$31739795deb20347() {
    if (!$3b2da6bf08d8f744$var$nativeEmbedFacade) $3b2da6bf08d8f744$var$nativeEmbedFacade = new $3b2da6bf08d8f744$export$3aace7af5e09b157((0, $6Iq0g.getExperienceManifestRegistry)(), (0, $h2POc.getSurfaceService)());
    return $3b2da6bf08d8f744$var$nativeEmbedFacade;
}





class $3b2da6bf08d8f744$export$3aace7af5e09b157 {
    /**
   * Registers an experience manifest so it can be matched by URL via {@link resolveManifestForUrl}.
   */ registerExperienceManifest(manifest) {
        this.experienceManifestRegistry.registerExperienceManifest(manifest);
    }
    /**
   * One-shot convenience method that registers experience manifests and
   * optionally configures the host surface in a single call.
   *
   * Prefer `setup()` over calling `registerExperienceManifest` /
   * `setSurface` individually — it makes the configuration declarative,
   * validates inputs eagerly, and guards against accidental double-setup.
   *
   * The low-level methods remain available for advanced use cases
   * (conditional registration, dynamic surface changes, etc.).
   *
   * @param config - The setup configuration.
   * @param config.experiences - Non-empty array of experience manifests to register.
   * @param config.surface - Optional surface configuration.
   *
   * Logs a warning and returns early if `setup()` has already been called.
   *
   * @example
   * ```ts
   * import { getNativeEmbedFacade } from '@atlassian/native-embeds-core';
   *
   * getNativeEmbedFacade().setup({
   *   experiences: [WhiteboardExperienceManifest, DBExperienceManifest],
   * });
   * ```
   */ setup(config) {
        if (this.isSetUp) {
            // eslint-disable-next-line no-console
            console.warn("NativeEmbedFacade.setup() has already been called. This call will be ignored. Use the low-level registerExperienceManifest() and setSurface() methods if you need to modify configuration after initial setup.");
            return;
        }
        for (const manifest of config.experiences)this.registerExperienceManifest(manifest);
        if (config.surface) this.setSurface(config.surface);
        if (config.cardClient) this.cardClient = config.cardClient;
        this.isSetUp = true;
    }
    /**
   * Sets the {@link CardClient} instance used for short-link URL resolution.
   *
   * This is useful when the `CardClient` is not available at the time `setup()`
   * is called (e.g. when the facade is initialised at module-load time before
   * the card provider is ready). Calling this after `setup()` replaces any
   * previously configured client.
   *
   * @param cardClient - The CardClient instance to use for ORS requests.
   */ setCardClient(cardClient) {
        this.cardClient = cardClient;
    }
    /**
   * Synchronous function that verifies if the URL matches any registered experience, and returns the experience ID if it does.
   * @param url - The URL to get the experience from.
   * @returns
   */ getExperienceIdFromUrl(url) {
        return this.experienceManifestRegistry.getExperienceIdFromUrl(url);
    }
    /**
   * Async variant of {@link getExperienceIdFromUrl} that handles Confluence
   * short-link URLs (e.g. `/wiki/x/<token>`).
   *
   * When the URL is a Confluence short link and a `cardClient` has been
   * configured (via `setup({ cardClient })` or `setCardClient()`), this method
   * resolves the short link to its canonical URL via the Object Resolver
   * Service and then matches the expanded URL against registered experience
   * manifests.
   *
   * Falls back to the synchronous {@link getExperienceIdFromUrl} for all
   * non-short-link URLs, or when no `cardClient` is available.
   *
   * @param url - The URL to resolve and match.
   * @returns The matched experience manifest ID, or `undefined` if no match.
   */ async getExperienceIdFromUrlAsync(url) {
        // Fast path: direct synchronous match (works for all non-short-link URLs)
        const syncResult = this.experienceManifestRegistry.getExperienceIdFromUrl(url);
        if (syncResult) return syncResult;
        // Expand Confluence short links via ORS when a cardClient is available
        const expandedUrl = await this.expandShortLink(url);
        if (!expandedUrl) return undefined;
        return this.experienceManifestRegistry.getExperienceIdFromUrl(expandedUrl);
    }
    /**
   * If `url` is a Confluence short link and a `cardClient` is configured,
   * resolves it to its canonical expanded URL via the Object Resolver Service.
   *
   * Returns `undefined` when:
   * - the feature gate `platform_native_embeds_rollout_non_maui_experience` is off,
   * - the URL is not a short link,
   * - no `cardClient` is available, or
   * - resolution fails or returns the same URL.
   */ async expandShortLink(url) {
        if (!(0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience')) return undefined;
        const isShortLink = $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN.test(url);
        if (!isShortLink || !this.cardClient) return undefined;
        try {
            const response = await this.cardClient.fetchData(url);
            const data = response?.data;
            if (!data || typeof data !== 'object') return undefined;
            const resolvedUrl = data['url'];
            if (typeof resolvedUrl === 'string' && resolvedUrl !== url) return resolvedUrl;
            // url can also be an object with an @id (JsonLd Link type)
            if (resolvedUrl && typeof resolvedUrl === 'object') {
                const id = resolvedUrl['@id'];
                if (typeof id === 'string' && id !== url) return id;
            }
        } catch  {
        // Short-link expansion is best-effort; fall through to return undefined.
        }
        return undefined;
    }
    /**
   * Synchronous function that returns the manifest for a URL if it matches any registered experience.
   * Uses `isUrlMatch` to find the matching manifest.
   * @param url - The URL to get the manifest for.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestByUrl(url) {
        return this.experienceManifestRegistry.getManifestByUrl(url);
    }
    /**
   * Synchronous function that returns the manifest for a given experience ID.
   * @param id - The experience manifest ID to look up.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestById(id) {
        return this.experienceManifestRegistry.getManifestById(id);
    }
    /**
   * Returns a list of all registered experience IDs.
   */ getAllExperienceIds() {
        return this.experienceManifestRegistry.getAllExperienceIds();
    }
    /**
   * Register or replace the active host surface.
   *
   * The surface provides capabilities that differ per host (editor, renderer,
   * etc.). The {@link Surface} interface will grow as new surface concerns
   * are identified.
   *
   * - Replaces any previously registered surface (last-write-wins).
   * - Pass `null` to clear the surface (e.g. on unmount).
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this.surfaceService.setSurface(surface);
    }
    /**
   * Finds the matching manifest for a URL and creates an experience.
   * Title metadata will be resolved later by Smart Card.
   *
   * When the URL is a Confluence short link (e.g. `/wiki/x/<token>`) and a
   * `cardClient` has been configured, the short link is expanded to its
   * canonical URL via the Object Resolver Service before manifest matching.
   * The experience is created with the expanded URL.
   */ async createExperienceForUrl(url) {
        // Reject non-URL strings early. macroParams.url may contain prose text
        // with an embedded link rather than a bare URL (e.g. after a bad paste).
        try {
            new URL(url);
        } catch  {
            return undefined;
        }
        const resolvedUrl = await this.expandShortLink(url) ?? url;
        const manifest = this.experienceManifestRegistry.getManifestByUrl(resolvedUrl);
        if (!manifest) return undefined;
        const urlMeta = {
            url: resolvedUrl,
            title: ''
        };
        // Lazy import — ExperienceService transitively pulls in
        // rovo-content-bridge-api which uses uuid/randomBytes. Keeping it out of
        // the static import graph prevents the SSR pre-compile crash.
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        const experience = getExperienceService().registerExperience({
            manifest: manifest,
            urlMeta: urlMeta
        });
        return {
            experience: experience,
            manifest: manifest
        };
    }
    /**
   * Unregister an experience and dispose its event listeners.
   *
   * Call when the embed is removed from the host surface (e.g. editor node
   * deleted, component unmount). This prevents memory leaks from stale
   * listener references.
   *
   * Safe to call with an ID that was never registered — it's a no-op.
   */ async destroyExperience(experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().unregisterExperience(experienceId);
    }
    /** Notify the child embed that its selection state changed. */ async sendSelectedChange(experienceId, selected) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().sendSelectedChange(experienceId, selected);
    }
    /** Notify the child embed that the embedded content should be read. */ async sendReadContent(experienceId) {
        if (!(0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return undefined;
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        return getExperienceService().sendReadContent(experienceId);
    }
    /** Register `aliasId` as a secondary ID for `experienceId`. Overwrites any previous mapping for `aliasId`. */ async addAlias(aliasId, experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().addAlias(aliasId, experienceId);
    }
    constructor(experienceManifestRegistry, surfaceService){
        this.experienceManifestRegistry = void 0;
        this.surfaceService = void 0;
        this.cardClient = void 0;
        this.isSetUp = false;
        this.experienceManifestRegistry = experienceManifestRegistry;
        this.surfaceService = surfaceService;
    }
}
module.exports["getNativeEmbedFacade"] = $3b2da6bf08d8f744$export$31739795deb20347;

});

parcelRegister("6Iq0g", function(module, exports) {
let $7626500f872d820e$var$experienceService;
function $7626500f872d820e$export$1b2983209f90e067() {
    if ($7626500f872d820e$var$experienceService) return $7626500f872d820e$var$experienceService;
    $7626500f872d820e$var$experienceService = new $7626500f872d820e$export$21c7ca9c95b7ce6b();
    return $7626500f872d820e$var$experienceService;
}
class $7626500f872d820e$export$21c7ca9c95b7ce6b {
    registerExperienceManifest(experienceManifest) {
        this.experienceManifests.push(experienceManifest);
    }
    safeIsUrlMatch(experience, url) {
        try {
            return experience.isUrlMatch(url);
        } catch  {
            return false;
        }
    }
    getExperienceIdFromUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url))?.id;
    }
    getManifestByUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url));
    }
    getManifestById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    getAllExperienceIds() {
        return this.experienceManifests.map((experience)=>experience.id);
    }
    async getExperienceById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    constructor(){
        this.experienceManifests = [];
    }
}
module.exports["getExperienceManifestRegistry"] = $7626500f872d820e$export$1b2983209f90e067;

});

parcelRegister("h2POc", function(module, exports) {
let $761c278f71652274$var$surfaceServiceInstance;
function $761c278f71652274$export$a019fb3db45daa2b() {
    if (!$761c278f71652274$var$surfaceServiceInstance) $761c278f71652274$var$surfaceServiceInstance = new $761c278f71652274$export$f9308bd8ae7f0c97();
    return $761c278f71652274$var$surfaceServiceInstance;
}
class $761c278f71652274$export$f9308bd8ae7f0c97 {
    /**
   * Register or replace the active host surface.
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this._surface = surface;
    }
    /**
   * Returns the currently active surface, or `null` if none is set.
   */ getSurface() {
        return this._surface;
    }
    constructor(){
        this._surface = null;
    }
}
module.exports["getSurfaceService"] = $761c278f71652274$export$a019fb3db45daa2b;

});

parcelRegister("eoNlM", function(module, exports) {

let $a7b996873e1209d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7b996873e1209d3$var$load("9njOW").then(()=>parcelRequire('ddI8y'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("99TtX", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $0232ad9c82d62a25$export$6dc7663b60a7f493 = (0, $8fPlA.experienceManifestId)('database');
const $0232ad9c82d62a25$var$isDatabaseUrl = (url)=>{
    return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null;
};
const $0232ad9c82d62a25$var$isDatabaseEntryUrl = (url)=>{
    try {
        return $0232ad9c82d62a25$var$isDatabaseUrl(url) && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $0232ad9c82d62a25$var$isDatabaseNonEntryUrl = (url)=>{
    return $0232ad9c82d62a25$var$isDatabaseUrl(url) && !$0232ad9c82d62a25$var$isDatabaseEntryUrl(url);
};
const $0232ad9c82d62a25$export$3db4c20f17f55c0a = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $0232ad9c82d62a25$export$6dc7663b60a7f493,
    isUrlMatch: $0232ad9c82d62a25$var$isDatabaseNonEntryUrl,
    parameterDefaults: {
        alwaysShowTitle: true
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.dbMoreItems)
            })
    }
};
module.exports["DBExperienceManifest"] = $0232ad9c82d62a25$export$3db4c20f17f55c0a;

});

parcelRegister("8fPlA", function(module, exports) {
const $63ee794f4378af50$export$32c943c51c185af3 = (s)=>s;
module.exports["experienceManifestId"] = $63ee794f4378af50$export$32c943c51c185af3;

});

parcelRegister("dx0Kw", function(module, exports) {
/* shared.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $4MdqE = parcelRequire("4MdqE");


var $lBKFk = parcelRequire("lBKFk");


var $k0CUL = parcelRequire("k0CUL");


var $1bzO2 = parcelRequire("1bzO2");


var $k9wGn = parcelRequire("k9wGn");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");

const $95d7871f626fca16$var$dbIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))),
    (0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
];
const $95d7871f626fca16$var$dbHandleChildCommands = (_experience, _command)=>{};
const $95d7871f626fca16$var$dbTransformUrl = (url, _isFullScreen)=>{
    const urlObj = new URL(url);
    urlObj.searchParams.set('presentationMode', 'nativeEmbedEditorPlugin');
    return urlObj.toString();
};
const $95d7871f626fca16$var$dbRenderLoadingComponent = (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
        animationDisabled: props.animationDisabled,
        icons: $95d7871f626fca16$var$dbIcons,
        testId: props.testId
    });
const $95d7871f626fca16$export$8f59efcb9ee755ea = ()=>{
    const itemsBeforeUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
    ];
    const itemsAfterUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
    ];
    return (0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? itemsAfterUpdate : itemsBeforeUpdate;
};
const $95d7871f626fca16$export$828ffb167e211671 = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
]; /**
                                                                                                                                                                         * Returns the "More options" dropdown items for the DB Entry embed.
                                                                                                                                                                         *
                                                                                                                                                                         * The "Always show title" toggle is gated on the `databases-native-embeds-v2`
                                                                                                                                                                         * experiment: it is only included when the experiment is enabled. Evaluated
                                                                                                                                                                         * lazily (rather than at module-load time) because the manifest is registered
                                                                                                                                                                         * before Statsig is bootstrapped.
                                                                                                                                                                         */ 
const $95d7871f626fca16$export$c84eb7789dc18 = ()=>{
    const items = [];
    if ((0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true)) items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE);
    items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY, (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE);
    return items;
};
const $95d7871f626fca16$export$2ef16a6e7258368a = {
    editorToolbarHandlers: {},
    renderLoadingComponent: $95d7871f626fca16$var$dbRenderLoadingComponent,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    appearance: 'minimal',
    showHeader: false,
    showBorder: false,
    waitForContentReady: true
};
const $95d7871f626fca16$export$28b94c65c51f8734 = {
    allowVerticalResize: true,
    isActive: ()=>true,
    handleChildCommands: $95d7871f626fca16$var$dbHandleChildCommands,
    lockResizeAspectRatio: ()=>false,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    transformUrl: $95d7871f626fca16$var$dbTransformUrl
};
module.exports["getDbToolbarItems"] = $95d7871f626fca16$export$8f59efcb9ee755ea;
module.exports["dbMoreItems"] = $95d7871f626fca16$export$828ffb167e211671;
module.exports["getDbEntryMoreItems"] = $95d7871f626fca16$export$c84eb7789dc18;
module.exports["dbSharedUiConfig"] = $95d7871f626fca16$export$2ef16a6e7258368a;
module.exports["dbSharedManifestFields"] = $95d7871f626fca16$export$28b94c65c51f8734;

});

parcelRegister("iPlb2", function(module, exports) {
/**
 * Core features that are supported by all native embeds.
 *
 * All native embed must either support the feature or respond in
 * the feature handshake that its not supported.
 */ const $9ebc30870bad8c95$export$189dc4df3d8f1369 = {
    /** When agreed, the parent sends selected-change events to the child when the embed's selection state changes. */ SelectedChange: 'selected-change',
    /** When agreed, the parent sends view-mode-change events to the child when the embed switches between regular and maximize (e.g. full screen). */ ViewModeChange: 'view-mode-change',
    /** When agreed, the parent sends header-visibility-change events to the child when the host native embed controls/chrome visibility changes. */ HeaderVisibilityChange: 'header-visibility-change',
    /** When agreed, the child captures click events and notifies the host via the bridge. */ NotifyHostClick: 'notify-host-click',
    /** When agreed, the child can request the host to toggle the full-screen dialog. */ ToggleFullScreen: 'toggle-full-screen',
    /**
	 * When agreed, the child can request the host to resize the embed container. */ RequestResize: 'request-resize',
    /**
	 * When agreed, the host sends `on-full-screen-changed` events to the child whenever
	 * the inline full-screen preview opens or closes WITHOUT remounting the iframe.
	 *
	 * This handshake is only ever negotiated when the host runs the shared-iframe
	 * code path (i.e. `Element.prototype.moveBefore` is supported). On any other
	 * host path the embed is torn down and re-created across the full-screen
	 * toggle, so a child has no need for this event.
	 */ NoRefreshFullScreenPreview: 'no-refresh-full-screen-preview',
    /**
	 * When agreed, the child sends a `content-ready` event to the host once its
	 * content is fully rendered and visible to the user. The host holds its own
	 * loading overlay visible until this event fires (or a safety timeout elapses),
	 * preventing a flash of the child's internal loading state between the iframe
	 * `load` event and the child's first painted frame.
	 *
	 * Only negotiated for embed types that set `waitForContentReady: true` in their
	 * `uiConfig`.
	 */ ContentReady: 'content-ready'
};
const $9ebc30870bad8c95$export$75135a796fe6e3e2 = Object.values($9ebc30870bad8c95$export$189dc4df3d8f1369);
module.exports["NativeEmbedCoreFeature"] = $9ebc30870bad8c95$export$189dc4df3d8f1369;
module.exports["allNativeEmbedCoreFeatures"] = $9ebc30870bad8c95$export$75135a796fe6e3e2;

});

parcelRegister("hjJUc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d31de4816ebba09$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bJ0qH = parcelRequire("bJ0qH");


var $39SCI = parcelRequire("39SCI");

function $3d31de4816ebba09$export$2e2bcd8739ae039(props) {
    if (props.variant === 'simple-bar') {
        const { variant: _variant, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39SCI.default), rest);
    }
    const { variant: _variant, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJ0qH.default), rest);
}

});

parcelRegister("bJ0qH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5675a156d46f0f78$export$2e2bcd8739ae039);
/* icon-carousel-variant.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $7lIlR = parcelRequire("7lIlR");


var $cr8hb = parcelRequire("cr8hb");

const $5675a156d46f0f78$var$containerStyles = null;
const $5675a156d46f0f78$var$innerStyles = null;
const $5675a156d46f0f78$var$progressBarWrapperStyles = null;
const $5675a156d46f0f78$var$defaultIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
function $5675a156d46f0f78$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId }) {
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrunmFW"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7lIlR.default), {
        animationDisabled: animationDisabled,
        icons: icons ?? $5675a156d46f0f78$var$defaultIcons,
        testId: testId ? `${testId}--${0, $g3Ghj.SLIDE_MORPH_TEST_ID_SUFFIX}` : undefined,
        cycleDirection: "right"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02lyjw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: "Loading",
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    }))));
}

});

parcelRegister("h5uPL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efca78d2ff84c46234bba0182469ec28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c70ad24a32d9055c$var$_react = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c70ad24a32d9055c$var$_baseNew = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c70ad24a32d9055c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sticker".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sticker
 * Usage guidance:
 * Used for sticker tool in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c70ad24a32d9055c$var$StickerIcon = (props)=>/*#__PURE__*/ $c70ad24a32d9055c$var$_react.default.createElement($c70ad24a32d9055c$var$_baseNew.default, Object.assign({
        name: "StickerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-1.998 12.687L6 14c0-1.102.223-2.153.627-3.11a8 8 0 0 1 7.56-4.888A6.5 6.5 0 0 0 8 1.5m5.413 6.026a6.5 6.5 0 0 0-5.404 3.947 6.5 6.5 0 0 0-.483 1.94zM0 8a8 8 0 0 1 15.899-1.277.75.75 0 0 1-.21.65l-8.317 8.315a.75.75 0 0 1-.649.21A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$c70ad24a32d9055c$var$StickerIcon.displayName = 'StickerIcon';
var $c70ad24a32d9055c$var$_default = module.exports.default = $c70ad24a32d9055c$var$StickerIcon;

});

parcelRegister("g3Ghj", function(module, exports) {
const $f9469b1871c63b69$export$422c871edd75db5 = 'progress-bar';
const $f9469b1871c63b69$export$eb09afb535a4cb18 = 'slide-morph';
const $f9469b1871c63b69$export$7442c4c7574447bc = 50;
module.exports["PROGRESS_BAR_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$422c871edd75db5;
module.exports["SLIDE_MORPH_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$eb09afb535a4cb18;
module.exports["STATIC_PROGRESS_VALUE"] = $f9469b1871c63b69$export$7442c4c7574447bc;

});

parcelRegister("bUupk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9ce3cf2ba109470$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e9ce3cf2ba109470$var$MIN_VALUE = 0;
const $e9ce3cf2ba109470$var$MAX_VALUE = 100;
const $e9ce3cf2ba109470$var$containerStyles = null;
const $e9ce3cf2ba109470$var$barStyles = null; /**
                         * This is a progress bar component that was built to match the atlaskit component `@atlaskit/progress-bar`.
                         * We couldn't use the atlaskit component due to the colour requirements for this progress bar not being supported,
                         * hence, a custom component was required.
                         */ 
function $e9ce3cf2ba109470$export$2e2bcd8739ae039({ ariaLabel: ariaLabel, testId: testId, value: value = 0 }) {
    const valueParsed = Math.max($e9ce3cf2ba109470$var$MIN_VALUE, Math.min(value, $e9ce3cf2ba109470$var$MAX_VALUE));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $e9ce3cf2ba109470$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $e9ce3cf2ba109470$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            width: `${valueParsed}%`
        },
        "data-testid": `${testId}--progress-value-bar`,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG _0KLXruXljP"
        ])
    }));
}

});

parcelRegister("7lIlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $948620dedd13543d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9NPFC = parcelRequire("9NPFC");


var $kVbnn = parcelRequire("kVbnn");


var $fEVaZ = parcelRequire("fEVaZ");

// so we override the background via a wrapper targeting the tile's root <span>.
const $948620dedd13543d$var$tileWrapperStyles = null;
function $948620dedd13543d$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId, cycleDirection: cycleDirection = 'right' }) {
    const iconsWithProps = icons.map((Icon)=>(props)=>/*#__PURE__*/ $cozmU.createElement(Icon, {
                color: "var(--ds-icon-subtle, #505258)",
                ...props
            }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0FoN3I7Cj1"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: "color.background.neutral",
        hasBorder: true,
        size: "xlarge",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEVaZ.default), {
        animationDisabled: animationDisabled,
        icons: iconsWithProps,
        cycleDirection: cycleDirection,
        testId: testId ? `${testId}--${0, $kVbnn.ICON_CYCLER_TEST_ID_SUFFIX}` : undefined
    })));
}

});

parcelRegister("kVbnn", function(module, exports) {
const $b041427678c4fb7b$export$a87bbf852b8799e2 = 'icon-cycler';
module.exports["ICON_CYCLER_TEST_ID_SUFFIX"] = $b041427678c4fb7b$export$a87bbf852b8799e2;

});

parcelRegister("fEVaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fded74c4bd3b5f47$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS = 900;
const $fded74c4bd3b5f47$var$ICON_CYCLE_TRANSITION_MS = 400;
const $fded74c4bd3b5f47$var$ICON_CYCLE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
const $fded74c4bd3b5f47$var$enteringAnimations = {
    left: "_1mT5xdRAKS _1gBibyJfTW",
    right: "_1mT5xdRAKS _1gBibyn5Jh"
};
const $fded74c4bd3b5f47$var$exitingAnimations = {
    left: "_1mT5xdWVPG _1gBibyGowt",
    right: "_1mT5xdWVPG _1gBiby958d"
};
const $fded74c4bd3b5f47$var$commonAnimationStyles = null;
const $fded74c4bd3b5f47$var$containerStyles = null;
const $fded74c4bd3b5f47$var$iconSlotStyles = null; /**
                              * Cycles through a list of icon components with a vertical slide transition.
                              *
                              * Each icon is shown for ICON_CYCLE_DELAY_MS, then the current icon slides
                              * out upward while the next icon slides in from below over ICON_CYCLE_TRANSITION_MS.
                              */ 
function $fded74c4bd3b5f47$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, cycleDirection: cycleDirection = 'left', testId: testId }) {
    const [currentIndex, setCurrentIndex] = (0, $cozmU.useState)(0);
    const [isTransitioning, setIsTransitioning] = (0, $cozmU.useState)(false);
    const timerRef = (0, $cozmU.useRef)(null);
    const nextIndex = (currentIndex + 1) % icons.length;
    const scheduleNextTransition = (0, $cozmU.useCallback)(()=>{
        timerRef.current = setTimeout(()=>{
            setIsTransitioning(true);
        }, $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS);
    }, []);
    const handleAnimationEnd = (0, $cozmU.useCallback)(()=>{
        setIsTransitioning(false);
        setCurrentIndex((prev)=>(prev + 1) % icons.length);
    }, [
        icons.length
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled || icons.length <= 1) return;
        if (!isTransitioning) scheduleNextTransition();
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        animationDisabled,
        icons.length,
        isTransitioning,
        scheduleNextTransition
    ]);
    if (icons.length === 0) return null;
    const CurrentIcon = icons[currentIndex];
    const NextIcon = icons[nextIndex];
    if (animationDisabled || icons.length === 1 || !isTransitioning) return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            "_0nFVCGpFbM _43vdfTBhmJ _3Y6bKpgRhm",
            $fded74c4bd3b5f47$var$exitingAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        onAnimationEnd: handleAnimationEnd,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            "_0nFVCGpFbM _43vdfTBhmJ _3Y6bKpgRhm",
            $fded74c4bd3b5f47$var$enteringAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(NextIcon, {
        label: ""
    })));
}

});

parcelRegister("cr8hb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g3Ghj = parcelRequire("g3Ghj");

function $e3f0b09e8c39256e$export$966e81c93dd9c110(animationDisabled) {
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? (0, $g3Ghj.STATIC_PROGRESS_VALUE) : 0);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) return;
        const interval = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 10) return prev + 10;
                if (prev < 60) return prev + 35;
                if (prev < 90) return prev + 10;
                return prev;
            });
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        animationDisabled
    ]);
    return progress;
}
module.exports["useFakeProgress"] = $e3f0b09e8c39256e$export$966e81c93dd9c110;

});

parcelRegister("39SCI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0a885121af4f63$export$2e2bcd8739ae039);
/* simple-bar-variant.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $cr8hb = parcelRequire("cr8hb");

const $4f0a885121af4f63$var$messages = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "native-embeds-core.common.loading-overlay.simple-bar-variant.loadingLabel",
        defaultMessage: "Loading"
    }
});
const $4f0a885121af4f63$var$containerStyles = null;
const $4f0a885121af4f63$var$blanketStyles = null;
const $4f0a885121af4f63$var$progressBarWrapperStyles = null;
function $4f0a885121af4f63$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, showBlanket: showBlanket = false, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLz9WS _37wbyuDIqT _0xmtko8HPE _0KLXrunmFW _42Yu6B7dHp"
        ])
    }, showBlanket && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _0KLXruA5lS"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02wOVE _1mT5xdRAKS _42Yu6B7dHp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: formatMessage($4f0a885121af4f63$var$messages.loadingLabel),
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    })));
}

});

parcelRegister("1NFwk", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $2b4557ff3d43825b$var$isDbEntryV2Enabled = ()=>(0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
/**
 * Returns the parameter defaults for the DB Entry embed.
 *
 * When v2 is enabled (see {@link isDbEntryV2Enabled}), new entry embeds
 * default to having the title visible (`alwaysShowTitle: true`),
 * matching the regular DB embed behaviour. Otherwise no override is
 * applied.
 */ const $2b4557ff3d43825b$var$getDbEntryParameterDefaults = ()=>$2b4557ff3d43825b$var$isDbEntryV2Enabled() ? {
        alwaysShowTitle: true
    } : {};
const $2b4557ff3d43825b$export$a8c9f0f28b60cece = (0, $8fPlA.experienceManifestId)('database-entry');
const $2b4557ff3d43825b$var$isDatabaseEntryUrl = (url)=>{
    try {
        return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $2b4557ff3d43825b$export$b0c2faa0f9dece58 = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $2b4557ff3d43825b$export$a8c9f0f28b60cece,
    isUrlMatch: $2b4557ff3d43825b$var$isDatabaseEntryUrl,
    get parameterDefaults () {
        return $2b4557ff3d43825b$var$getDbEntryParameterDefaults();
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        get appearance () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled() ? 'overlay' : 'minimal';
        },
        get showBorder () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled();
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.getDbEntryMoreItems)()
            })
    }
};
module.exports["DBEntryExperienceManifest"] = $2b4557ff3d43825b$export$b0c2faa0f9dece58;

});

parcelRegister("9F0bu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $1pCE4 = parcelRequire("1pCE4");


var $b5sDq = parcelRequire("b5sDq");


var $dazTo = parcelRequire("dazTo");


var $6Ec6w = parcelRequire("6Ec6w");


var $gJ798 = parcelRequire("gJ798");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $gqUuL = parcelRequire("gqUuL");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $d2e69b3762c8c591$var$mauiLoadingIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dazTo)))
];
const $d2e69b3762c8c591$export$b0111d5aa9d78690 = (0, $8fPlA.experienceManifestId)('maui');
const $d2e69b3762c8c591$var$MAUI_DEFAULT_WIDTH_KILLSWITCH = 'native_embeds_maui_default_width_killswitch';
const $d2e69b3762c8c591$var$isMauiUrl = (url)=>/\/remix\/ui\/[A-Za-z0-9_-]+/.test(url); /**
                                                                                      * Experience manifest for a MAUI embed.
                                                                                      * Register with getNativeEmbedFacade().registerExperienceManifest(MauiExperienceManifest),
                                                                                      * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
                                                                                      */ 
const $d2e69b3762c8c591$export$f519d88de7ad4d5e = {
    allowMaxWidth: true,
    id: $d2e69b3762c8c591$export$b0111d5aa9d78690,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $d2e69b3762c8c591$var$isMauiUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    lockResizeAspectRatio: ()=>!(0, $iDrrr.fg)('cc_maui_resize'),
    narrowEmbedThreshold: 50,
    parameterDefaults: {
        get width () {
            return (0, $iDrrr.fg)($d2e69b3762c8c591$var$MAUI_DEFAULT_WIDTH_KILLSWITCH) ? 760 : undefined;
        }
    },
    shouldFocusOnClick: (_url, _meta)=>!(0, $iDrrr.fg)('cc_maui_editing'),
    transformUrl: (url, _isFullScreen, options)=>{
        const urlObj = new URL(url);
        const { colorMode: colorMode } = (0, $gqUuL.default)();
        if (colorMode) urlObj.searchParams.set('theme', colorMode);
         // When the host Confluence page is in edit mode, forward an
        // `enable-edits=` query param (empty value) so the embedded MAUI app
        // can render its edit-only affordances.
        if (options?.isEditMode) urlObj.searchParams.set('enable-edits', '');
        return urlObj.toString();
    },
    // remove this when MAUI is onboarded to the Linking Platform. This is here to allow testing before it is onboarded.
    resolveViaLinkingPlatform: false,
    uiConfig: {
        trackViewed: true,
        showBorder: false,
        showExpandButton: false,
        renderLoadingComponent: (props)=>{
            // The exposure is fired at the toolbar click in `duplicate-and-replace-maui-app.ts`.
            if ((0, $anBbz.expValEqualsNoExposure)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true)) return /*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                variant: "simple-bar",
                animationDisabled: props.animationDisabled,
                showBlanket: props.source === 'ai-edit',
                testId: props.testId
            });
            return /*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $d2e69b3762c8c591$var$mauiLoadingIcons,
                testId: props.testId
            });
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                customActions: {},
                items: [
                    ...(0, $iDrrr.fg)('cc-maui-phase-2') ? (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    ...(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? (0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ],
                moreItems: []
            }),
        editorToolbarHandlers: {
            onAskRovoClick: (_parameters, context)=>{
                const editorApi = context?.editorApi; // Stage the embed as the inline-Rovo streaming target. The overlay
                // is NOT triggered here — `RovoPromptScreenWithLogic.onSubmit`
                // promotes this on prompt submit. `expValEquals` (NOT NoExposure)
                // because this toolbar click is the designated `cc-maui-experiment`
                // exposure point.
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-experiment + cc-maui-phase-2); will simplify post-rollout
                (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) && (0, $iDrrr.fg)('cc-maui-phase-2')) {
                    const localId = context?.selectedNodeLocalId;
                    if (localId) editorApi?.aiExperience?.actions?.stageInlineRovoStreaming?.(localId);
                }
                editorApi?.aiExperience?.actions?.openAIModal?.({
                    invokedFrom: 'floatingToolbar'
                });
            }
        },
        fullScreenDialogControls: {
            hideOpenInNewTab: true,
            hideTitleIcon: true
        },
        headerControls: {
            hideMoreMenu: true,
            hideTitle: true
        },
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))),
        appearance: 'overlay'
    }
};
module.exports["MAUI_EXPERIENCE_MANIFEST_ID"] = $d2e69b3762c8c591$export$b0111d5aa9d78690;
module.exports["MauiExperienceManifest"] = $d2e69b3762c8c591$export$f519d88de7ad4d5e;

});

parcelRegister("dazTo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3281ca8f41c384f29d16055797a6b9db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99680d0c3dba17d6$var$_react = $99680d0c3dba17d6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $99680d0c3dba17d6$var$_baseNew = $99680d0c3dba17d6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $99680d0c3dba17d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "World".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/world
 * Usage guidance:
 * Known uses: Geographical data visualization.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99680d0c3dba17d6$var$WorldIcon = (props)=>/*#__PURE__*/ $99680d0c3dba17d6$var$_react.default.createElement($99680d0c3dba17d6$var$_baseNew.default, Object.assign({
        name: "WorldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/><path fill="currentcolor" d="M9.5 12.13a2.63 2.63 0 0 1 2.63-2.63H15V11h-2.87c-.62 0-1.12.5-1.12 1.13V15H9.5zm-1.5.62a2 2 0 0 0-2-2 .5.5 0 0 1-.5-.5v-.5A2.5 2.5 0 0 0 3 7.25H1v1.5h2a1 1 0 0 1 1 1v.5a2 2 0 0 0 2 2 .5.5 0 0 1 .5.5V15H8zm-1.25-6.5A.75.75 0 0 0 6 5.5h-.25A2.5 2.5 0 0 1 3.25 3V1.63h1.5V3a1 1 0 0 0 1 1H6a2.25 2.25 0 0 1 2.25 2.25c0 .41.34.75.75.75h1.5a.5.5 0 0 0 .5-.5 2 2 0 0 1 2-2h1.75V6H13a.5.5 0 0 0-.5.5 2 2 0 0 1-2 2H9a2.25 2.25 0 0 1-2.25-2.25"/>`
    }, props));
$99680d0c3dba17d6$var$WorldIcon.displayName = 'WorldIcon';
var $99680d0c3dba17d6$var$_default = module.exports.default = $99680d0c3dba17d6$var$WorldIcon;

});

parcelRegister("85cI7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $5FKld = parcelRequire("5FKld");


var $iDrrr = parcelRequire("iDrrr");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");

const $ec6282bd715404c7$export$7bda1cade81459d3 = (0, $8fPlA.experienceManifestId)('maui-whiteboard'); /**
                                                                                                                      * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                                      * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                                      * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                                      * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                                      */ 
const $ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH = 'platform_native_embed_rovo_remix_title';
const $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE = 'https://native-embeds.invalid';
const $ec6282bd715404c7$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
]; /**
                                                                                              * Captures the whiteboard resource id from a Confluence whiteboard URL. Numeric
                                                                                              * ids and UUIDs are both in use.
                                                                                              */ 
// eslint-disable-next-line require-unicode-regexp
const $ec6282bd715404c7$var$WHITEBOARD_RESOURCE_ID_REGEX = /\/whiteboard\/([^/?#]+)/; /**
                                                                 * A whiteboard embed's identity is its content id. The space segment is vanity
                                                                 * (the rendered canvas URL is `/canvas-embed/whiteboard/{referenceId}` and has no
                                                                 * space key), and the streaming params are transient, so neither changes which
                                                                 * board is being shown.
                                                                 *
                                                                 * Scoped to the MAUI experience on purpose. The in-editor Remix finalize keeps
                                                                 * `isRemixDiagram=true` on the rewritten URL, so both the streaming and finalized
                                                                 * URLs still match this manifest — which `main.tsx` registers ahead of the generic
                                                                 * whiteboard one — and identity resolves from here on both sides of the rewrite.
                                                                 *
                                                                 * The paste path is deliberately not covered: `buildMovedUrl` strips
                                                                 * `isRemixDiagram`, so its finalized URL falls through to the generic `whiteboard`
                                                                 * manifest, which has no identity and therefore keeps the existing URL-keyed
                                                                 * teardown. That path's reload is already largely masked because the move fires on
                                                                 * the tick after paste, while the board is still loading. Extending identity to
                                                                 * the generic manifest would change behaviour for every non-MAUI Confluence
                                                                 * whiteboard embed, which is not worth it for this fix.
                                                                 */ 
const $ec6282bd715404c7$var$getWhiteboardContentIdentity = (url)=>{
    const resourceId = $ec6282bd715404c7$var$WHITEBOARD_RESOURCE_ID_REGEX.exec(url)?.[1];
    if (!resourceId) return undefined;
    try {
        return `whiteboard:${decodeURIComponent(resourceId)}`;
    } catch  {
        return `whiteboard:${resourceId}`;
    }
};
const $ec6282bd715404c7$var$isMauiWhiteboardUrl = (url)=>{
    const isWhiteboardPath = url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
    if (!isWhiteboardPath) return false;
    try {
        return new URL(url).searchParams.get('isRemixDiagram') === 'true';
    } catch  {
        return false;
    }
}; /**
    * Reads search params from either an absolute embed URL or a relative iframe
    * src such as `/canvas-embed/whiteboard/...`. The placeholder base is only
    * used by `URL` to parse relative URLs; absolute URLs keep their own origin
    * and nothing is requested from this host.
    */ 
const $ec6282bd715404c7$var$getSearchParamFromEmbedUrl = (url, param)=>{
    try {
        return new URL(url, $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE).searchParams.get(param);
    } catch  {
        return null;
    }
};
const $ec6282bd715404c7$var$shouldHideRovoRemixTitle = (url)=>{
    // Killswitch: platform_native_embed_rovo_remix_title
    // false (default) = hide intermediary Rovo remix titles; true = rollback
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH, 'value', false)) return false;
    return $ec6282bd715404c7$var$getSearchParamFromEmbedUrl(url, 'parentProduct') === 'rovo';
}; /**
    * Experience manifest for a MAUI whiteboard embed — a whiteboard created through
    * the MAUI (remix diagram) flow.
    *
    * Register with getNativeEmbedFacade().registerExperience(MauiWhiteboardExperienceManifest)
    * to obtain an Experience for EmbedFrameUI.
    */ 
const $ec6282bd715404c7$export$72612bab14c2e7fe = {
    id: $ec6282bd715404c7$export$7bda1cade81459d3,
    getContentIdentity: $ec6282bd715404c7$var$getWhiteboardContentIdentity,
    isUrlMatch: $ec6282bd715404c7$var$isMauiWhiteboardUrl,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures),
        (0, $5FKld.WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE)
    ]),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true'); // Default the parent product for MAUI whiteboards when the native embed
        // URL doesn't already specify one. native-embeds-core re-applies this
        // onto the ORS-resolved iframe src (which otherwise defaults to
        // `smartlink`). An existing value (e.g. `rovo`) is preserved.
        if (!urlObj.searchParams.has('parentProduct')) urlObj.searchParams.set('parentProduct', 'nativeEmbedDiagram');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        trackViewed: true,
        isAskRovoEnabled: ()=>(0, $iDrrr.fg)('cc-maui-phase-2'),
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    ...(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        headerControls: {
            hideTitle: ({ url: url })=>$ec6282bd715404c7$var$shouldHideRovoRemixTitle(url)
        },
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $ec6282bd715404c7$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: true
    },
    handleChildCommands: (_experience, _cmd)=>{}
};
module.exports["MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID"] = $ec6282bd715404c7$export$7bda1cade81459d3;
module.exports["MauiWhiteboardExperienceManifest"] = $ec6282bd715404c7$export$72612bab14c2e7fe;

});

parcelRegister("5FKld", function(module, exports) {
const $0debf512440368ae$export$2e20e907dc949166 = 'whiteboard-viewport-alignment';
const $0debf512440368ae$export$47b7df6411961030 = 'whiteboard-viewport-alignment-change';
function $0debf512440368ae$export$ac67ecac1191542d(alignment) {
    switch(alignment){
        case 'left':
        case 'wrap-left':
            return 'left';
        case 'center':
            return 'center';
        case 'right':
        case 'wrap-right':
            return 'right';
    }
}
module.exports["WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE"] = $0debf512440368ae$export$2e20e907dc949166;
module.exports["WHITEBOARD_VIEWPORT_ALIGNMENT_CHANGE_COMMAND"] = $0debf512440368ae$export$47b7df6411961030;
module.exports["normalizeWhiteboardViewportAlignment"] = $0debf512440368ae$export$ac67ecac1191542d;

});

parcelRegister("1xINT", function(module, exports) {

var $gqUuL = parcelRequire("gqUuL");


var $fcaWu = parcelRequire("fcaWu");

const $d5e4138f0844ba8b$export$6f4b285026a87b72 = ()=>{
    const theme = (0, $gqUuL.default)();
    if (Object.keys(theme).length === 0) return undefined;
    return (0, $fcaWu.themeObjectToString)(theme);
};
module.exports["getInitialThemeParam"] = $d5e4138f0844ba8b$export$6f4b285026a87b72;

});

parcelRegister("7tMWI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gC2EJ = parcelRequire("gC2EJ");


var $hMaHH = parcelRequire("hMaHH");


var $4GyjL = parcelRequire("4GyjL");


var $d4GYd = parcelRequire("d4GYd");


var $UL6rM = parcelRequire("UL6rM");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $f5f0a9f7a4b49836$export$7870b2bb7b39809b = (0, $8fPlA.experienceManifestId)('page');
const $f5f0a9f7a4b49836$var$pageIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
    (0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4GyjL)))
]; // Match page URLs: /wiki/spaces/<key>/pages/<id>
// Match blog URLs: /wiki/spaces/<key>/blog/<id> or /wiki/spaces/<key>/blog/<year>/<month>/<day>/<id>
const $f5f0a9f7a4b49836$var$pagePathPattern = /\/wiki\/spaces\/[^/]+\/(pages\/\d+|blog\/(\d+\/){0,3}\d+)/;
const $f5f0a9f7a4b49836$var$pageShortLinkUrlPattern = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $f5f0a9f7a4b49836$var$isPageUrl = (url)=>{
    if ($f5f0a9f7a4b49836$var$pagePathPattern.test(url)) return true;
     // Preserve the legacy Page native embed match until the EditorCardProvider shortlink flow is
    // rolled out. Removing it while the gate is off would regress existing shortlink native embeds.
    return $f5f0a9f7a4b49836$var$pageShortLinkUrlPattern.test(url) && !(0, $iDrrr.fg)('platform_native_embeds_enable_shortlink_resolution');
};
const $f5f0a9f7a4b49836$var$isEditUrl = (url)=>/\/wiki\/spaces\/[^/]+\/(pages|blog)\/(edit-embed|edit-v2)\/\d+/.test(url); // PGXT-10098: keep blog icons correct before resolved metadata is available.
const $f5f0a9f7a4b49836$var$blogPathPattern = /\/wiki\/spaces\/[^/]+\/blog\//;
const $f5f0a9f7a4b49836$var$isBlogUrl = (url)=>{
    try {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(new URL(url).pathname);
    } catch  {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(url);
    }
};
const $f5f0a9f7a4b49836$var$resolveTitleIcon = (meta, url)=>{
    if (meta.documentType === 'schema:DigitalDocument') return 0, (/*@__PURE__*/$parcel$interopDefault($kLlYX));
    if (meta.documentType === 'schema:BlogPosting' || $f5f0a9f7a4b49836$var$isBlogUrl(url)) return 0, (/*@__PURE__*/$parcel$interopDefault($d4GYd));
    return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
}; /**
    * Experience manifest for a page embed.
    * Register with getNativeEmbedFacade().registerExperienceManifest(PageExperienceManifest),
    * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
    */ 
const $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc = {
    enforceQueryParams: true,
    id: $f5f0a9f7a4b49836$export$7870b2bb7b39809b,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $f5f0a9f7a4b49836$var$isPageUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    shouldFocusOnClick: (url, meta)=>{
        // Don't steal focus for live docs (documentType === 'schema:DigitalDocument')
        if (meta.documentType === 'schema:DigitalDocument') return false;
         // Don't steal focus when the page is in edit mode
        if ($f5f0a9f7a4b49836$var$isEditUrl(url)) return false;
        return true;
    },
    transformUrl: (url, _isFullScreen)=>{
        const urlObj = new URL(url);
        urlObj.searchParams.set('sample-param', 'true');
        return urlObj.toString();
    },
    uiConfig: {
        showHeader: (_meta, url)=>!$f5f0a9f7a4b49836$var$isEditUrl(url),
        headerControls: {
            editButton: {
                show: (meta)=>meta.documentType !== 'schema:DigitalDocument',
                // Don't show edit button for live docs
                onSwitchToEditing: (currentUrl, originalUrl)=>{
                    const url = new URL(currentUrl); // Detect whether this is originally a blog URL. The iframe's internal
                    // SPA router may resolve blog URLs (e.g. /blog/2026/04/29/<id>) to
                    // their canonical /pages/<id> form, so iframeSrc (currentUrl) may
                    // show /pages/<id> even for blogs. We check the originalUrl (the URL
                    // before iframe navigation) to detect blogs reliably; fall back to
                    // the current URL when no originalUrl is provided.
                    const contentIsBlog = $f5f0a9f7a4b49836$var$isBlogUrl(originalUrl ?? currentUrl);
                    if (contentIsBlog) {
                        // Blogs use /blog/edit-v2/<id> because there is no /blog/edit-embed/ route,
                        // which would cause a redirect that strips native embed query params.
                        // Extract the content ID from either the blog URL or the resolved /pages/<id> URL.
                        const blogMatch = url.pathname.match(/\/blog\/(?:\d+\/\d+\/\d+\/)?(\d+)(?:\/[^/]*)?$/);
                        const pagesMatch = url.pathname.match(/\/pages\/(\d+)/);
                        const contentId = blogMatch?.[1] ?? pagesMatch?.[1];
                        if (contentId) // Replace the path portion after /spaces/<key>/ with /blog/edit-v2/<id>
                        url.pathname = url.pathname.replace(/\/spaces\/([^/]+)\/.*$/, `/spaces/$1/blog/edit-v2/${contentId}`);
                    } else // Pages use /pages/edit-embed/<id> (dedicated embedded editor route).
                    url.pathname = url.pathname.replace(/\/pages\/(\d+)/, '/pages/edit-embed/$1');
                    url.searchParams.set('initialAllowedFeatures', 'delete-draft');
                    return url.toString();
                },
                onSwitchToViewing: (currentUrl, _originalUrl)=>{
                    const url = new URL(currentUrl); // Reverse the edit URL transforms back to view URLs
                    url.pathname = url.pathname.replace(/\/pages\/edit-embed\/(\d+)/, '/pages/$1').replace(/\/blog\/edit-v2\/(\d+)/, '/blog/$1');
                    url.searchParams.delete('initialAllowedFeatures');
                    return url.toString();
                }
            }
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    ...(0, $iDrrr.fg)('maui_remixable_page_native_embeds') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $f5f0a9f7a4b49836$var$pageIcons,
                testId: props.testId
            }),
        resolveTitleIcon: $f5f0a9f7a4b49836$var$resolveTitleIcon,
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        appearance: 'overlay'
    }
};
module.exports["PageExperienceManifest"] = $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc;

});

parcelRegister("8iBLq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $8kONW = parcelRequire("8kONW");


var $kWSTb = parcelRequire("kWSTb");


var $fZ5ji = parcelRequire("fZ5ji");


var $bYNUA = parcelRequire("bYNUA");


var $cFvoT = parcelRequire("cFvoT");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $dc247be55b77c9b0$var$slideIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bYNUA))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fZ5ji)))
];
const $dc247be55b77c9b0$export$7f3e59c853b03788 = (0, $8fPlA.experienceManifestId)('slide'); /**
                                                                                                  * Experience manifest for a slide embed.
                                                                                                  * Register with getNativeEmbedFacade().registerExperience(SlideExperienceManifest)
                                                                                                  * to obtain a Experience for EmbedFrameUI.
                                                                                                  */ 
const $dc247be55b77c9b0$export$513ec3204bdf9ec = {
    id: $dc247be55b77c9b0$export$7f3e59c853b03788,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: (url)=>(0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true) && (0, $8kONW.isConfluenceSlideUrl)(url),
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    queryParams: {
        disableCanvasScroll: 'true'
    },
    isActive: ()=>(0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true),
    // Slides have a 16:9 canvas; set the default embed dimensions to 16:10 with a little extra height cause it looks nicer.
    parameterDefaults: {
        width: 960,
        height: 600
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    // BUILTIN_TOOLBAR_KEYS.ASK_ROVO, // Removed until correct context from embed is provided https://product-fabric.atlassian.net/browse/CNS-29056
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $dc247be55b77c9b0$var$slideIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        appearance: 'overlay'
    }
};
module.exports["SlideExperienceManifest"] = $dc247be55b77c9b0$export$513ec3204bdf9ec;

});

parcelRegister("fZ5ji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36849515f8f6102bc425fa817120d55a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba30ac06fca117d5$var$_react = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ba30ac06fca117d5$var$_baseNew = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ba30ac06fca117d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoMiniplayer".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-miniplayer
 * Usage guidance:
 * Reserved for picture-in-picture functionality for videos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba30ac06fca117d5$var$VideoMiniplayerIcon = (props)=>/*#__PURE__*/ $ba30ac06fca117d5$var$_react.default.createElement($ba30ac06fca117d5$var$_baseNew.default, Object.assign({
        name: "VideoMiniplayerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm4.75 4a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 .75.75v2.75a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$ba30ac06fca117d5$var$VideoMiniplayerIcon.displayName = 'VideoMiniplayerIcon';
var $ba30ac06fca117d5$var$_default = module.exports.default = $ba30ac06fca117d5$var$VideoMiniplayerIcon;

});

parcelRegister("aaqIB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $5FKld = parcelRequire("5FKld");


var $iDrrr = parcelRequire("iDrrr");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");


var $7wdoX = parcelRequire("7wdoX");

const $af71dcb44dbd21c6$export$571bdd0f87630d48 = (0, $8fPlA.experienceManifestId)('whiteboard'); /**
                                                                                                            * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                            * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                            * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                            * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                            */ 
const $af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $af71dcb44dbd21c6$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
const $af71dcb44dbd21c6$var$isWhiteboardUrl = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?")); /**
                                                                                                                                                                                                                                     * Experience manifest for a whiteboard embed.
                                                                                                                                                                                                                                     * Register with getNativeEmbedFacade().registerExperience(WhiteboardExperienceManifest)
                                                                                                                                                                                                                                     * to obtain a Experience for EmbedFrameUI.
                                                                                                                                                                                                                                     */ 
const $af71dcb44dbd21c6$export$257420b954ccf94c = {
    id: $af71dcb44dbd21c6$export$571bdd0f87630d48,
    handleChildCommands: (_experience, cmd)=>{
        switch(cmd.type){
            case (0, $7wdoX.NativeEmbedChildCommandType).FreezeFrameResponse:
                break;
            case (0, $7wdoX.NativeEmbedChildCommandType).UnfreezeFrameResponse:
                break;
        }
    },
    isUrlMatch: $af71dcb44dbd21c6$var$isWhiteboardUrl,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures),
        (0, $5FKld.WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE)
    ]),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $af71dcb44dbd21c6$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: true
    }
};
module.exports["WhiteboardExperienceManifest"] = $af71dcb44dbd21c6$export$257420b954ccf94c;

});

parcelRegister("7wdoX", function(module, exports) {
var $3d7fb527228d62f2$export$e02855afa78b2d37 = /*#__PURE__*/ function(NativeEmbedCommandType) {
    NativeEmbedCommandType["FreezeFrameRequest"] = "freezeFrameRequest";
    NativeEmbedCommandType["UnfreezeFrame"] = "unfreezeFrame";
    return NativeEmbedCommandType;
}({});
var $3d7fb527228d62f2$export$f17561b95ea7b258 = /*#__PURE__*/ function(NativeEmbedChildCommandType) {
    NativeEmbedChildCommandType["FreezeFrameResponse"] = "freezeFrameResponse";
    NativeEmbedChildCommandType["UnfreezeFrameResponse"] = "unfreezeFrameResponse";
    return NativeEmbedChildCommandType;
}({});
module.exports["NativeEmbedChildCommandType"] = $3d7fb527228d62f2$export$f17561b95ea7b258;

});

parcelRegister("bx1QU", function(module, exports) {

let $8654369a26d87200$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8654369a26d87200$var$load("8T2wY"),
    $8654369a26d87200$var$load("aMsb0"),
    $8654369a26d87200$var$load("2PXrC"),
    $8654369a26d87200$var$load("6wr18"),
    $8654369a26d87200$var$load("3evar"),
    $8654369a26d87200$var$load("fEHF5"),
    $8654369a26d87200$var$load("9njOW"),
    $8654369a26d87200$var$load("7EorR"),
    $8654369a26d87200$var$load("ffEVr"),
    $8654369a26d87200$var$load("bY4kf")
]).then(()=>parcelRequire('htIUR'));

});

parcelRegister("8bRAb", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $dWfVs = parcelRequire("dWfVs");


var $aJNFh = parcelRequire("aJNFh");


var $2TWQD = parcelRequire("2TWQD");

async function $22de9e431e2baedb$export$af16a73460e35e28(cloudId, config) {
    const allSkills = await (0, $aJNFh.fetchSkills)(cloudId);
    const filteredSkills = (0, $2TWQD.filterSkills)(allSkills, config);
    return (0, $dWfVs.buildSkillsManifest)(filteredSkills, {
        // Skills should appear below native editor elements in the slash menu.
        // A high priority value (lower importance) ensures native items rank
        // higher when search scores are equal. Skills are identified by their
        // extensionType property (set by buildMenuItem for all extension items)
        // in the reranker at
        // platform/packages/editor/editor-common/src/quick-insert/boost-native-results-above-skills.ts
        priority: config.priority ?? 9000,
        onAction: (skill)=>{
            config.onAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
                attributes: {
                    skillSlug: skill.slug,
                    skillName: skill.name,
                    isAiSkill: true
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            });
            return config.onSkillSelected?.(`/${skill.slug}`, skill);
        }
    });
}
module.exports["createRovoSkillsExtensionManifest"] = $22de9e431e2baedb$export$af16a73460e35e28;

});

parcelRegister("dWfVs", function(module, exports) {

var $8lhhf = parcelRequire("8lhhf");


var $9MCKh = parcelRequire("9MCKh");

const $ad58f4ad7597918e$var$DEFAULT_CATEGORY = 'AI';
const $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH = 150;
/**
 * Truncate description to a maximum length.
 * Used to keep insert menu items readable when skill descriptions are long.
 */ function $ad58f4ad7597918e$var$truncateDescription(description) {
    if (description.length <= $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH) return description;
    return description.slice(0, $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH).trim() + "\u2026";
}
/**
 * Returns the skill-specific icon based on the iconName field.
 * Falls back to the default skill icon if no match is found.
 */ const $ad58f4ad7597918e$var$getSkillIcon = (iconName)=>iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
function $ad58f4ad7597918e$export$d76981760c7a9606(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $ad58f4ad7597918e$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes } = options;
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        return {
            key: skill.slug,
            title: skill.name,
            description: $ad58f4ad7597918e$var$truncateDescription(skill.helpText ?? skill.description ?? ''),
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $ad58f4ad7597918e$var$getSkillIcon(skill.iconName),
            ...getLozenge && {
                lozenge: getLozenge(skill)
            },
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: 'Rovo Skills',
        description: 'AI-powered skills from Rovo',
        type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $9MCKh.defaultIcon),
            '24': (0, $9MCKh.defaultIcon),
            '48': (0, $9MCKh.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
module.exports["buildSkillsManifest"] = $ad58f4ad7597918e$export$d76981760c7a9606;

});

parcelRegister("2TWQD", function(module, exports) {
function $e8e957862ffce1cf$export$757808344f89f413(skills, config) {
    if (config.showAllSkills) return skills;
    const allowedSlugs = config.allowedSkills ?? [];
    if (allowedSlugs.length === 0) return [];
    const skillsBySlug = new Map(skills.map((skill)=>[
            skill.slug,
            skill
        ]));
    return allowedSlugs.map((slug)=>skillsBySlug.get(slug)).filter((skill)=>skill !== undefined);
}
module.exports["filterSkills"] = $e8e957862ffce1cf$export$757808344f89f413;

});

parcelRegister("cOau5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9iGS2 = parcelRequire("9iGS2");


var $F4YLX = parcelRequire("F4YLX");

const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    const baseExtension = (0, $9iGS2.getRedactionExtension)();
    const baseNodes = baseExtension.modules.nodes ?? {};
    return {
        ...baseExtension,
        modules: {
            ...baseExtension.modules,
            nodes: {
                ...baseNodes,
                default: {
                    ...baseNodes.default,
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("9iGS2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8Iwqw = parcelRequire("8Iwqw");


var $2W6JM = parcelRequire("2W6JM");

const $18242b0ae588a593$var$EXTENSION_TYPE = 'com.atlassian.guard-premium';
const $18242b0ae588a593$export$fd010a581322717b = (getSpotlightKey)=>({
        [$18242b0ae588a593$var$EXTENSION_TYPE]: ()=>{
            if (getSpotlightKey) {
                const key = getSpotlightKey();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
                    name: `redaction-marker-${key}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2W6JM.RedactionMarker), null));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2W6JM.RedactionMarker), null);
        }
    });

const $18242b0ae588a593$export$12bebc06194b8864 = ()=>{
    return {
        title: 'Redaction',
        type: $18242b0ae588a593$var$EXTENSION_TYPE,
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            '48': ()=>(parcelRequire("b4ALZ"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(0, $2W6JM.RedactionMarker),
                    // Redacted content must not be copyable; hide the copy button
                    // from the selection toolbar (delete-only).
                    hideCopyButton: true
                }
            }
        }
    };
};
module.exports["getRedactionExtension"] = $18242b0ae588a593$export$12bebc06194b8864;

});

parcelRegister("2W6JM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $biXSc = parcelRequire("biXSc");

const $41ad4d5eece5004a$var$redactionBarStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    aspectRatio: '3.4/1',
    height: '1lh',
    '@supports not (height: 1lh)': {
        height: '1.5em'
    },
    backgroundColor: 'color.background.neutral.bold.pressed',
    verticalAlign: 'middle',
    position: 'relative',
    // Redacted content must not be selectable/copyable.
    userSelect: 'none'
});
function $41ad4d5eece5004a$export$5d1828a8b51af09e() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if ((0, $iDrrr.fg)('jira-redaction-accessibility-followup')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($41ad4d5eece5004a$var$RedactionBar, {
        "aria-label": formatMessage((0, $biXSc.default).redactionMarker)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        xcss: $41ad4d5eece5004a$var$redactionBarStyles
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $41ad4d5eece5004a$var$RedactionBar = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_16fwhxg": (0, $9aYkv.default)(CSS.supports('height', '1lh') ? '1lh' : '1.5em')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3v5uP0XfP4 _0jFU0VAamP _0KLXruy7kJ _1RrJLit2nV _1mT5xdRAKS _20VacPYbGa",
            __cmplp.className
        ])
    });
});
module.exports["RedactionMarker"] = $41ad4d5eece5004a$export$5d1828a8b51af09e;

});

parcelRegister("biXSc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $309f8ed8a1d2a206$var$_default_1 = (0, $kSwu1.defineMessages)({
    redactionMarker: {
        id: "editor-extensions.redaction-extension.redaction-marker-aria-label",
        defaultMessage: "Redacted content. Your organization has removed sensitive data."
    }
});
var $309f8ed8a1d2a206$export$2e2bcd8739ae039 = $309f8ed8a1d2a206$var$_default_1;
module.exports["default"] = $309f8ed8a1d2a206$export$2e2bcd8739ae039;

});

parcelRegister("b4ALZ", function(module, exports) {

let $80fc97cf3f3f4d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80fc97cf3f3f4d02$var$load("gCHto").then(()=>parcelRequire('47bbw'));

});


//# sourceMappingURL=ClassicEditorContextProvider.db889558.js.map
